import zanzibar from "../assets/zanzibar.jpg";
import senegal from "../assets/senegal.jpg";
import kenya from "../assets/kenya.jpg";
import namibia from "../assets/namibia.jpg";
import ivoryCoast from "../assets/ivory-coast.jpg";
import ghana from "../assets/ghana.jpg";
import morocco from "../assets/morocco.jpg";
import southAfrica from "../assets/south-africa.jpg";
import madagascar from "../assets/madagascar.jpg";
import tunisia from "../assets/tunisia.jpg";

const countries = [
  { id: 1, image: zanzibar, name: "Zanzibar" },
  { id: 2, image: senegal, name: "Senegal" },
  { id: 3, image: kenya, name: "Kenya" },
  { id: 4, image: namibia, name: "Namibia" },
  { id: 5, image: ivoryCoast, name: "Ivory Coast" },
  { id: 6, image: ghana, name: "Ghana" },
  { id: 7, image: morocco, name: "Morocco" },
  { id: 8, image: tunisia, name: "Tunisia" },
  { id: 9, image: southAfrica, name: "South Africa" },
  { id: 10, image: madagascar, name: "Madagascar" },
];

export default countries;
